const GROUPING_COMMAND_LABELS = {
  grouping: 'Grouping',
  regrouping: 'Regrouping',
  ungrouping: 'Ungrouping',
  workspaceGrouping: 'Regrouping'
};

export const GROUPING_COMMAND_TYPES = Object.keys(GROUPING_COMMAND_LABELS);

export const isGroupingCommandType = (commandType) => Object.prototype.hasOwnProperty.call(
  GROUPING_COMMAND_LABELS,
  commandType
);

export const getGroupingCommandProgressLabel = (commandType) => {
  const label = GROUPING_COMMAND_LABELS[commandType];
  if (!label) return null;
  return `${label}...`;
};

export const getGroupingCommandFinishedLabel = (commandType) => {
  const label = GROUPING_COMMAND_LABELS[commandType];
  if (!label) return null;
  return `Done! ${label} successfully finished.`;
};
